import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.42871 14.0713H9.5C9.73669 14.0713 9.92871 14.2633 9.92871 14.5V20.5713C9.92871 20.808 9.73669 21 9.5 21H3.42871C3.19202 21 3 20.808 3 20.5713V14.5C3 14.2633 3.19202 14.0713 3.42871 14.0713ZM14.5 14.0713H20.5713C20.808 14.0713 21 14.2633 21 14.5V20.5C21 20.7367 20.808 20.9287 20.5713 20.9287H14.5C14.2633 20.9287 14.0713 20.7367 14.0713 20.5V14.5C14.0713 14.2633 14.2633 14.0713 14.5 14.0713ZM3.42871 3H9.5C9.73669 3 9.92871 3.19202 9.92871 3.42871V9.5C9.92871 9.73669 9.73669 9.92871 9.5 9.92871H3.42871C3.19202 9.92871 3 9.73669 3 9.5V3.42871L3.00879 3.3418C3.04891 3.1467 3.22175 3 3.42871 3ZM14.5 3H20.5713C20.808 3 21 3.19202 21 3.42871V9.5C21 9.73669 20.808 9.92871 20.5713 9.92871H14.5C14.2633 9.92871 14.0713 9.73669 14.0713 9.5V3.42871C14.0713 3.19202 14.2633 3 14.5 3Z",
		stroke: "#324051",
		strokeWidth: 2
	})
});
export default SvgHome;
